<template>
  <div>
    <a-form layout="horizontal">
      <a-row :gutter="24">
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="核查因子">
            <a-select v-model="formData.factorCode" placeholder="请选择" :disabled="disableSubmit" @change="onFactorChange">
              <a-select-option v-for="f in factorOptions" :key="f.code" :value="f.code">{{ f.name }}（{{ f.unit }}）</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仪器量程">
            <a-input-number v-model="formData.instrumentRange" :disabled="disableSubmit" style="width: 80%" />
            <span style="margin-left: 5px">{{ formData.factorUnit }}</span>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 多点数据表格（高点、中点、低点） -->
      <a-row>
        <a-col :span="24">
          <qc-point-table ref="pointTable" :pointConfig="st31PointConfig" :initPoints="initPoints"
            :disableSubmit="disableSubmit" :unit="formData.factorUnit" errorMode="st31" :showResponseTime="true"
            :instrumentRange="formData.instrumentRange" :factorCode="formData.factorCode"
            @point-change="onPointChange" />
        </a-col>
      </a-row>

      <!-- 汇总 -->
      <a-row :gutter="24" style="margin-top: 15px">
        <a-col :md="8" :sm="24">
          <a-form-item :labelCol="{ span: 14 }" :wrapperCol="{ span: 10 }" label="示值误差最大绝对值">
            <span>{{ formData.maxIndicationError != null ? formData.maxIndicationError + '%' : '--' }}</span>
          </a-form-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-item :labelCol="{ span: 14 }" :wrapperCol="{ span: 10 }" label="响应时间平均值">
            <span>{{ formData.avgResponseTime != null ? formData.avgResponseTime + ' s' : '--' }}</span>
          </a-form-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否合格">
            <a-select v-model="formData.qualified" :disabled="disableSubmit" placeholder="请选择">
              <a-select-option value="yes">合格</a-select-option>
              <a-select-option value="no">不合格</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :md="24">
          <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="备注">
            <a-textarea v-model="formData.remark" :disabled="disableSubmit" placeholder="请输入备注" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row style="margin-top: 5px">
        <a-col>

          <iws-upload ref="itemUpload" :options="{ btnText: '上传附件' }" :disableSubmit="disableSubmit"
            filesrc="om_qc_st31_item" :srcid="formData.id" />
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import IwsUpload from '@comp/upload/IwsUpload.vue'
import QcPointTable from './QcPointTable'

export default {
  name: 'St31QuarterForm',
  components: { QcPointTable, IwsUpload },
  props: {
    disableSubmit: { type: Boolean, default: false },
    siteId: { type: [Number, String], default: null },
    st: { type: String, default: '31' },
    pagePath: { type: String, default: '/om/qc/ledger' },
    dataItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      formData: {
        id: null, qcMeasure: 'indication_error',
        factorCode: undefined, factorName: '', factorUnit: '',
        instrumentRange: null, maxIndicationError: null, avgResponseTime: null,
        qualified: undefined, remark: '',
      },
      factorOptions: [], initPoints: [],
      labelCol: { span: 8 }, wrapperCol: { span: 16 },
      /** ST31多点：高点、中点、低点 */
      st31PointConfig: [
        { pointName: 'high', pointSort: 1 },
        { pointName: 'mid', pointSort: 2 },
        { pointName: 'low', pointSort: 3 },
      ],
    }
  },
  watch: {
    dataItems: { immediate: true, handler(val) {
      if (val && val.length > 0) { this.formData = { ...this.formData, ...val[0] }; this.initPoints = val[0].points || [] }
    }},
  },
  created() { this.loadFactors() },
  methods: {
    loadFactors() {
      if (!this.siteId) return
      Promise.all([
        getAction(this.pagePath + '/factorWhitelist', { st: '31', qcMeasure: 'indication_error' }),
        getAction('/site/info/factor/find/' + this.siteId)
      ]).then(([resWhite, resSite]) => {
        if (resWhite.success && resWhite.result) {
          let siteFactors = (resSite.success && resSite.result) ? resSite.result : []
          let options = []
          resWhite.result.forEach((c) => {
            let f = siteFactors.find((sf) => sf.code === c)
            if (f) options.push({ code: c, name: f.title, unit: f.unitName || '' })
          })
          this.factorOptions = options
        }
      })
    },
    onFactorChange(code) {
      let f = this.factorOptions.find((i) => i.code === code)
      if (f) { this.formData.factorCode = f.code; this.formData.factorName = f.name; this.formData.factorUnit = f.unit }
    },
    onPointChange(points) {
      // 示值误差最大绝对值
      let errors = points.filter((p) => p.errorValue != null).map((p) => Math.abs(p.errorValue))
      this.formData.maxIndicationError = errors.length > 0 ? Math.max(...errors) : null
      // 响应时间平均值
      let times = points.filter((p) => p.responseTotal != null).map((p) => p.responseTotal)
      this.formData.avgResponseTime = times.length > 0 ? Math.trunc(times.reduce((a, b) => a + b, 0) / times.length * 100) / 100 : null
    },
    collectData() {
      if (!this.formData.factorCode) { this.$message.warning('请选择核查因子'); return null }
      let points = this.$refs.pointTable.getPointsData()
      if (this.$refs.itemUpload) {
        let fd = this.$refs.itemUpload.getUploadList ? this.$refs.itemUpload.getUploadList() : {}
        this.formData.sysFileList = fd.sysFileList || []; this.formData.fileDelList = fd.fileDelList || []
      }
      return [{ ...this.formData, points }]
    },
  },
}
</script>
